// Düzenleme modunda kullanıcı fiyat girdilerine dokunmadan "Update" yaparsa kayıtlı fiyatı koru.
// Aksi halde güncel kurlar ya da değişen hesaplama kuralları yüzünden, hiçbir şey
// değiştirilmeden kaydedilen bir teklifin satış fiyatı / marjı sessizce değişiyordu.

// Kullanıcının girdiği, fiyatı belirleyen alanlar
const PRICING_INPUT_FIELDS = [
    "carriers",
    "extraCosts",
    "pickupService",
    "deliveryService",
    "roadPricingMode",
    "oceanPricingMode",
    "airPricingMode",
    "originCustomsClearance",
    "originCost",
    "originCurrency",
    "destinationCustomsClearance",
    "destinationCost",
    "destinationCurrency",
    "originSallingRate",
    "originSallingRateCurrency",
    "destinationSallingRate",
    "destinationSallingRateCurrency",
    "currency",
];

// Girdilerden hesaplanan (kur / kurala bağlı) alanlar
const PRICING_OUTPUT_FIELDS = [
    "sallingRate",
    "marginPercent",
    "marginPerUnit",
    "totalCarrierSelling",
    "totalExtraSelling",
    "totalBuying",
    "totalExtraBuying",
];

const isBlank = (v) =>
    v === null || v === undefined || v === "" || v === 0 || v === "0" || (Array.isArray(v) && v.length === 0);

const toComparable = (v) => {
    if (isBlank(v)) return null;
    if (typeof v === "number") return Math.round(v * 100) / 100;
    if (typeof v === "string") {
        const s = v.trim();
        return s !== "" && !Number.isNaN(Number(s)) ? Math.round(Number(s) * 100) / 100 : s;
    }
    return v;
};

// Formun gönderdiği değer ile kayıttaki değer aynı mı? Sadece formun gönderdiği anahtarlar karşılaştırılır
// (kayıttaki _id gibi ek alanlar fark sayılmaz).
const sameValue = (sent, saved) => {
    if (Array.isArray(sent)) {
        const savedArr = Array.isArray(saved) ? saved : [];
        if (sent.length !== savedArr.length) return false;
        return sent.every((item, i) => sameValue(item, savedArr[i]));
    }
    if (sent && typeof sent === "object") {
        if (saved == null) return Object.values(sent).every((v) => isBlank(v) || v === false);
        return Object.keys(sent).every((k) => sameValue(sent[k], saved[k]));
    }
    if (typeof sent === "boolean" || typeof saved === "boolean") return Boolean(sent) === Boolean(saved);
    return toComparable(sent) === toComparable(saved);
};

/**
 * Fiyat girdileri kayıttakiyle aynıysa payload'daki hesaplanmış fiyat alanlarını kayıttaki değerlerle değiştirir.
 * lineSelling=false iken satış fiyatı elle girilen bir alan olduğundan, o da değişmemiş olmalı.
 * @returns {boolean} kayıtlı fiyatın korunup korunmadığı
 */
export const keepSavedPricingIfUntouched = (payload, saved, lineSelling) => {
    if (!payload || !saved) return false;

    const inputsUnchanged = PRICING_INPUT_FIELDS.every(
        (key) => !(key in payload) || sameValue(payload[key], saved[key])
    );
    if (!inputsUnchanged) return false;
    if (!lineSelling && !sameValue(payload.sallingRate, saved.sallingRate)) return false;

    PRICING_OUTPUT_FIELDS.forEach((key) => {
        if (key in payload && saved[key] !== undefined && saved[key] !== null) {
            payload[key] = saved[key];
        }
    });
    return true;
};

// Ekrandaki hesap kayıtlı fiyattan farklıysa kullanıcıya gösterilecek not (yoksa "")
export const savedPricingNotice = (saved, currentSelling) => {
    if (!saved) return "";
    const savedSelling = Number(saved.sallingRate);
    const current = Number(currentSelling);
    if (!Number.isFinite(savedSelling) || !Number.isFinite(current)) return "";
    if (Math.abs(savedSelling - current) < 0.01) return "";
    const cur = saved.currency || "";
    return (
        `Saved selling price is ${savedSelling.toFixed(2)} ${cur}, but the current calculation gives ` +
        `${current.toFixed(2)} ${cur} (exchange rates or calculation rules changed). ` +
        "If you don't change any pricing fields, the saved price is kept on update."
    );
};
